
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/getting-started-delayed-send-microsoft-teams",
      function () {
        return require("private-next-pages/article/getting-started-delayed-send-microsoft-teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/getting-started-delayed-send-microsoft-teams"])
      });
    }
  